import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { AppBar } from '../AppBar'
import { Header } from './Header'
import { Body } from './Body'
import { Table } from './Table'
import { FooterCat } from '../Catalan/FooterCat'
import { FooterCast } from '../Castellano/FooterCast'
import { AlignJustify, HeartMinus, ListFilterPlus } from 'lucide-react'
import { Computer } from 'lucide-react'
import { Tabs } from '../AppComponents/Tabs'
import { TableObjetos } from './TableObjetos'
import { fetchPenalizacionesByUser, updatePenalizacionesToYaPenalizado } from '../Apis/penalizacion/penalizacion'
import { TablePenalizaciones } from './TablePenalizaciones'
import { Intercanviat } from './intercanviat/Intercanviat'

export function AreaPersonal() {
    const location = useLocation()
    const { id } = useParams()
    const [language, setLanguage] = useState('castellano')
    const [penalizaciones, setPenalizaciones] = useState([])

    useEffect(() => {
        const lang = location.state?.language ?? 'castellano'
        setLanguage(lang)
    }, [location.state])

    useEffect(() => {
        handlePenalizaciones(id)
        updatePenalizacionesToYaPenalizado(id)
    }, [id])

    const handlePenalizaciones = async (userId) => {
        const penalizaciones = await fetchPenalizacionesByUser(userId)

        setPenalizaciones(penalizaciones)
    }

    const tabs = [
        {
            label: language === 'castellano' ? 'Mis penalizaciones' : 'Les meves penalitzacions',
            children: <TablePenalizaciones penalizaciones={penalizaciones} language={language} />,
            icon: <HeartMinus />,
        },
        {
            label: language === 'castellano' ? 'Mis talleres' : 'Els meus tallers',
            children: (
                <>
                    <Header language={language} />
                    <Body language={language} />
                    <Table language={language} userId={id} />
                </>
            ),
            icon: <AlignJustify />,
        },
        {
            label: language === 'castellano' ? 'Objetos en depósito' : 'Objectes en dipòsit',
            children: <TableObjetos language={language} userId={id} />,
            icon: <Computer />,
        },
        {
            label: 'Intercanviat',
            children: <Intercanviat language={language} userId={id} />,
            icon: <ListFilterPlus />,
        },
    ]

    return (
        <>
            <div className="d-flex flex-column min-vh-100">
                <div className="container-md flex-grow-1">
                    <AppBar language={language} setLanguage={setLanguage} logged={true} />
                    <div className="mt-4">
                        <Tabs tabs={tabs} variant="pills" />
                    </div>
                </div>
                {language === 'castellano' ? <FooterCast /> : <FooterCat />}
            </div>
        </>
    )
}
